import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Zap } from "lucide-react";

export default function LastMinuteSlots({ refreshKey }) {
  const [slots, setSlots] = useState([]);
  useEffect(() => { api.get("/slots", { params: { last_minute: true, only_available: true } }).then((r) => setSlots(r.data)).catch(() => {}); }, [refreshKey]);

  return (
    <div className="mt-10" data-testid="last-minute-section">
      <h2 className="text-2xl font-bold text-slate-900 flex items-center gap-2"><Zap className="w-6 h-6 text-amber-500" /> Créneaux de dernière minute</h2>
      <p className="text-sm text-slate-600 mt-1">Réservés aux coachs approuvés par la salle. Vous les voyez car une salle vous a validé.</p>
      <div className="mt-4 grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {slots.map((s) => (
          <Link key={s.id} to={`/salles/${s.room?.id}`} data-testid={`last-minute-slot-${s.id}`} className="sc-card border-amber-300 bg-amber-50/40 hover:ring-2 hover:ring-amber-300 transition">
            <div className="text-[10px] uppercase tracking-wider font-bold text-amber-700">Dernière minute</div>
            <div className="font-bold text-slate-900">{s.room?.name}</div>
            <div className="text-sm text-slate-700">{new Date(s.start).toLocaleString("fr-FR", { weekday: "short", day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" })}</div>
            <div className="mt-1 text-sm text-emerald-700 font-semibold">{s.price || s.room?.price_per_hour}€</div>
          </Link>
        ))}
        {slots.length === 0 && <div className="sc-card text-sm text-slate-500">Aucun créneau de dernière minute pour le moment. Faites-vous approuver par vos salles en réservant chez elles.</div>}
      </div>
    </div>
  );
}
